export enum APIEndpoint {
    SESSIONS = '/sessions',
    DEALS = '/deals',
    MERCHANTS = '/deals/merchants',
    MERCHANT = '/deals/merchant',
    CATEGORIES = '/categories'
}